import { createFileRoute } from '@tanstack/react-router'
import CreatePurchaseInvoiceScreen from './-components/screen'
import { pharmacyClient } from '@/connect'
import { Supplier } from '@/gen/suppliers/common_pb'
import { GetStockPointsResponse } from '@/gen/branch/get_stock_points_pb'
import { PurchaseOrder } from '@/gen/purchase_order/common_pb'
import dayjs from 'dayjs'

export const Route = createFileRoute('/(inventory)/branch/_layout/purchase-invoices/create/')({
  component: CreatePurchaseInvoiceScreen,
  loader: async (): Promise<{
    suppliers: Supplier[]
    purchaseOrders: PurchaseOrder[]
    stockPoints: GetStockPointsResponse
  }> => {
    const suppliers = await pharmacyClient.listSuppliers({
      page: 1,
      pageSize: 1000,
    })
    const purchaseOrders = await pharmacyClient.listPurchaseOrders({
      pageNumber: 1,
      pageSize: 1000,
      includeUsed: false, // Only get unused POs
    })
    const stockPoints = await pharmacyClient.getStockPoints({
      startDate: dayjs().subtract(30, 'day').unix(),
      endDate: dayjs().unix(),
    })
    return {
      suppliers: suppliers.suppliers as Supplier[],
      purchaseOrders: purchaseOrders.purchaseOrders || [],
      stockPoints: stockPoints,
    }
  }
})